export class FilterNode {
  private _data: any
  private _parent: FilterNode
  private _children: FilterNode[]

  constructor(data: any) {
    this._data = data
  }

  readData(): any {
    return this._data
  }

  getParentNode(): FilterNode {
    return this._parent
  }

  setParentNode(parent: FilterNode) {
    this._parent = parent
  }

  getChildren(): FilterNode[] {
    return this._children
  }

  addChildren(childrenNodeList: FilterNode[]) {
    this._children = childrenNodeList
    childrenNodeList.forEach((filterNode: FilterNode) => {
      filterNode.setParentNode(this)
    })
  }
}
